// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_2UI2c","dataHookWrapper":"_2UI2c","core-badge":"_1uSlU","coreBadge":"_1uSlU"};